var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileCategoriesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8528 1.82042L19.5429 4.02552C21.1356 4.48221 22.0565 6.14354 21.5998 7.73622L18.5678 18.3101C18.1111 19.9028 16.4498 20.8237 14.8571 20.367L7.16701 18.1619C5.57434 17.7052 4.65345 16.0438 5.11014 14.4512L8.14215 3.87729C8.59884 2.28462 10.2602 1.36373 11.8528 1.82042Z",
    stroke: "#404554",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.28322,
    y: 5.29657,
    width: 14,
    height: 17,
    rx: 3,
    fill: "white",
    stroke: "#404554",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.46468,
    y: 9.0351,
    width: 5,
    height: 5,
    stroke: "#404554",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCategoriesInactive);
export default __webpack_public_path__ + "static/media/MobileCategoriesInactive.ee8deceb.svg";
export { ForwardRef as ReactComponent };